import type { TOCItem, TOCParent } from '~/common/types';
import { matchSearch } from '~/helpers/matchSearch';

/** Which of the picker's lists a section is rendered in. */
export type PickerGroup = 'within' | 'outside' | 'extra';

export const expansionKey = (group: PickerGroup, section: { sectionId?: string; label: string }): string =>
  `${group}:${section.sectionId ?? section.label}`;

const isTOCParent = (item: TOCItem): item is TOCParent => 'children' in item;

export const filterTreeBySearch = (items: TOCItem[], searchTerm: string): TOCItem[] => {
  if (searchTerm === '') return items;

  return items.flatMap<TOCItem>((item) => {
    if (!isTOCParent(item)) return matchSearch(item.label, searchTerm) ? [item] : [];
    if (matchSearch(item.label, searchTerm)) return [item];

    const children = filterTreeBySearch(item.children, searchTerm);
    return children.length > 0 ? [{ ...item, children }] : [];
  });
};
